import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const InstoreAdOffersRootActionPath = 'core/InstoreAdOffers';

export const INSTORE_AD_OFFERS_GET_SUCCESS = `${InstoreAdOffersRootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const INSTORE_AD_OFFERS_GET_FAILURE = `${InstoreAdOffersRootActionPath}/GET_${FAILURE_SUFFIX}`;
export const INSTORE_AD_OFFERS_CONTENT_GROUP_ID = 'core/instoreAdOffersContentGroupId/Info';

export const INSTORE_AD_OFFERS_VIEW = 'core/instoreAdOffers/View';
